<div class="dob">
  <div class="dob__label">
    <ion-label>{{ question.label }}</ion-label>
  </div>

  <div class="input-group">
    <input [name]="question.key" [(ngModel)]="question.answer" class="offscreen" required tabindex="-999" #dateInput="ngModel" />

    <div class="dob__fields" [class.has-error]="question.error">
      <select
        class="form-control day"
        name="{{ question.key }}.day"
        required
        #dd="ngModel"
        [(ngModel)]="day"
        (ngModelChange)="question.error = null"
        (blur)="checkSave()"
        (keydown.enter)="checkSave()"
        (cdkAutofill)="checkSave()">
        <option class="dob__option" [value]="null" disabled selected>Day</option>
        <option class="dob__option" *ngFor="let d of days" [value]="d">{{ d }}</option>
      </select>

      <select
        class="form-control month"
        name="{{ question.key }}.month"
        required
        #mm="ngModel"
        [(ngModel)]="month"
        (ngModelChange)="question.error = null"
        (blur)="checkSave()"
        (keydown.enter)="checkSave()"
        (cdkAutofill)="checkSave()">
        <option class="dob__option" [value]="null" disabled selected>Month</option>
        <option class="dob__option" *ngFor="let m of months; index as i" [value]="i">{{ m }}</option>
      </select>

      <select
        class="form-control year"
        name="{{ question.key }}.year"
        required
        #yy="ngModel"
        [(ngModel)]="year"
        (blur)="save$.next(null)"
        (ngModelChange)="question.error = null"
        (cdkAutofill)="checkSave()">
        <option class="dob__option" [value]="null" disabled selected>Year</option>
        <option class="dob__option" *ngFor="let y of years" [value]="y">{{ y }}</option>
      </select>
    </div>
  </div>
</div>
